export class EntityCollection {
  constructor(items, order) {
    this.items = items || [];
    this.order = order || [];

    this.update = function (item) {
      this.items[item.id] = item;
    };

    this.add = function (item) {
      this.items[item.id] = item;
      this.order.push(item.id);
    };

    this.upsert = function (item) {
      if (this.items[item.id]) {
        this.update(item);
      } else {
        this.add(item);
      }
    };

    this.remove = function (item) {
      if (this.items[item.id]) {
        this.order = this.order.filter(itemId => itemId !== item.id);
        delete this.items[item.id];
      }
    };

    this.clearItems = function () {
      this.items = [];
      this.order = [];
    };

    this.merge = function (entityCollection) {
      // This appends the new records, and removed duplicates.
      this.order = [
        ...new Set([
          ...this.order,
          ...entityCollection.order
        ])
      ];

      // Any Duplicates will be overwritten by the new data
      this.items = {...this.items, ...entityCollection.items};
    };
  }
}
